import React, { Component } from 'react'
import { DepartmentConsumer, DepartmentContextType } from './DepartmentContext'
import isEqual from 'lodash/isEqual'

/**
 * Update the DepartmentProvider's active department on mount.
 *
 * This abstracts the tedious logic of managing state changes of the DepartmentContext.
 */
interface DepartmentSetterProps {
  newDepartment?: DepartmentContextType['department']
  setDepartment: DepartmentContextType['setDepartment']
}

class DepartmentSetter extends Component<DepartmentSetterProps> {
  public constructor(props: DepartmentSetterProps) {
    super(props)

    if (this.props.setDepartment) {
      this.props.setDepartment(this.props.newDepartment || null)
    }
  }

  public componentWillMount() {
    if (this.props.setDepartment) {
      this.props.setDepartment(this.props.newDepartment || null)
    }
  }

  /**
   * TODO: Safer to always `setDepartment` on updates?
   */
  public componentDidUpdate(prevProps: DepartmentSetterProps) {
    // If the department has changed, set it again
    if (!isEqual(prevProps.newDepartment, this.props.newDepartment) && this.props.setDepartment) {
      this.props.setDepartment(this.props.newDepartment || null)
    }

    // If the setter wasn't initially available, set it now
    if (!prevProps.setDepartment && this.props.setDepartment) {
      this.props.setDepartment(this.props.newDepartment || null)
    }
  }

  // public componentWillUnmount() {
  //   if (this.props.setDepartment) {
  //     this.props.setDepartment(null)
  //   }
  // }

  public render() {
    return this.props.children || null
  }
}

/**
 * Wrap the DepartmentSetterOnMount, passing through the new department as well as the setter
 */
interface DepartmentSetterInjectorProps {
  department?: DepartmentContextType['department']
}

const DepartmentSetterInjector: React.FC<DepartmentSetterInjectorProps> = ({
  department,
  children
}) => {
  return (
    <DepartmentConsumer>
      {({ setDepartment }) => (
        <DepartmentSetter newDepartment={department} setDepartment={setDepartment}>
          {children}
        </DepartmentSetter>
      )}
    </DepartmentConsumer>
  )
}

export default DepartmentSetterInjector
